import React, { Suspense } from 'react';
import {
    FullScreen,
    HeaderBlock,
    ContentBlock
} from './style';

import TitleHeader from 'components/presenters/header/TitleHeader'; 
import LoadingModal from 'components/presenters/modal/LoadingModal';

const TermsAndConditionModal = ({visible, onClose}) => {
    if(!visible) return null;
    const TermsAndConditions = React.lazy(() => import('components/containers/mypage/TermsAndConditions'));
    return (
        <FullScreen>
            <HeaderBlock>
                <TitleHeader onBackBtn={onClose} title={'이용 약관'}/>
            </HeaderBlock>
            <ContentBlock>
                <Suspense fallback={<LoadingModal zIndex={500}/>}>
                    <TermsAndConditions />
                </Suspense>
            </ContentBlock>
        </FullScreen>
    );
};
 
export default TermsAndConditionModal;